<template>
    <template v-if="!loading">
        <ion-item-divider color="light">
            <ion-label slot="start"><strong>Classificatie</strong></ion-label>

            <ion-label slot="end" class="ion-text-end mr-5">
                <small class="light-label">{{ $store.getters.getInspectionMethodCode }}</small>
            </ion-label>
        </ion-item-divider>

        <!-- CONFINED classification method -->
        <ion-list v-if="$store.getters.getInspectionMethodCode == 'CONF'" :inset="true" class="mt-2">
            <ion-item :disabled="loading" lines="inset">
                <ion-label>Resultaat</ion-label>
                <ion-chip slot="end" color="success" class="mr-0 my-3">
                    <strong>{{ classification_result }}</strong>
                </ion-chip>
            </ion-item>
        </ion-list>

        <!-- IB22 classification method -->
        <ion-list v-else-if="$store.getters.getInspectionMethodCode == 'IB22'" :inset="true">
            <ion-item v-if="classification_optional" lines="inset">
                <ion-label>Classificeer als defect</ion-label>
                <ion-toggle :disabled="disabled" slot="end" v-model="editable_model.is_defect"
                    @ionChange="$emit('isDefect', editable_model.is_defect)">
                </ion-toggle>
            </ion-item>
            <transition name="level">
                <div v-if="editable_model.is_defect">

                    <select-row key="1" :disabled="disabled" label="Gevaaraspect"
                        v-model:value="classification_result.danger_aspect_id" :items="danger_aspects" field_name="name"
                        field_value="id" :truncate="false" />

                    <select-row key="2" label="Verwacht gevolg"
                        v-model:value="classification_result.error_indication_id" :items="getErrorIndications"
                        field_name="name" field_value="id"
                        :disabled="!classification_result.danger_aspect_id || disabled" @change="setErrorClassification"
                        :truncate="false" />

                    <select-row key="3" label="Classificatie"
                        v-model:value="classification_result.error_classification_id" :items="error_classifications"
                        field_name="name" field_value="id"
                        :disabled="!classification_result.error_indication_id || disabled" @change="setRepairPeriod"
                        :truncate="false" />

                    <select-row key="4" label="Herstelperiode" v-model:value="classification_result.repair_period_id"
                        :items="repair_periods" field_name="name" field_value="id"
                        :disabled="!classification_result.error_classification_id || disabled" :truncate="false" />

                    <ion-item key="5" lines="inset">
                        <ion-label position="stacked">Herstelactie (optioneel)</ion-label>
                        <ion-textarea :disabled="disabled" v-model="classification_result.repair_advice" rows="3"
                            placeholder="Herstelactie"></ion-textarea>
                    </ion-item>
                </div>
            </transition>
        </ion-list>
    </template>
</template>
<script>
import { db } from '@/services/db';
import SelectRow from '@/components/SelectRow.vue'

export default {
    name: "ClassificationComponent",
    props: {
        model: {
            type: Object,
            required: true
        },
        classification_optional: {
            type: Boolean,
            default: false
        },

    },
    components: {
        SelectRow,
    },
    data() {
        return {
            loading: false,
            editable_model: null,
            classification_result: null,
            danger_aspects: [],
            error_indications: [],
            error_classifications: [],
            repair_periods: [],
        }
    },
    emits: ["change"],
    created() {
        this.setup()
    },
    methods: {
        async setup() {
            this.loading = true
            this.editable_model = JSON.parse(JSON.stringify(this.model))

            // CONFINED LOGIC
            if (this.$store.getters.getInspectionMethodCode === 'CONF') {
                const fields = this.editable_model.rules.fields.filter(field => field.classification_field);

                if (!fields.length) {
                    this.classification_result = 'Geen classificatie';
                    return;
                }

                const classifications = fields
                    .map(field => {
                        // Zoek de optie die overeenkomt met de geselecteerde waarde
                        const selectedOption = field.options.find(option => option.value === field.value);
                        if (selectedOption && selectedOption.classification_value) {
                            const value = selectedOption.classification_value;
                            const number = parseInt(value, 10); // Haal het nummer uit de waarde
                            const letter = value.replace(number, ''); // Haal de letter uit de waarde
                            return { number, letter };
                        }
                        return null;
                    })
                    .filter(classification => classification !== null); // Filter velden zonder geldige classificatie

                if (classifications.length) {
                    const highest = classifications.reduce((max, current) => {
                        if (current.number > max.number) {
                            return current;
                        } else if (current.number === max.number) {
                            return current.letter > max.letter ? current : max;
                        }
                        return max;
                    });

                    this.classification_result = `${highest.number}${highest.letter}`;
                } else {
                    this.classification_result = 'Geen classificatie';
                }

                console.log('classification_result', this.classification_result);
            } else
                if (this.$store.getters.getInspectionMethodCode == 'IB22') {

                    this.danger_aspects = await db.danger_aspects.toArray()
                    this.error_indications = await db.error_indications.toArray()
                    this.error_classifications = await db.error_classifications.toArray()
                    this.repair_periods = await db.repair_periods.toArray()

                    // sort all on order (contains number)
                    this.danger_aspects.sort((a, b) => a.order - b.order)
                    this.error_indications.sort((a, b) => a.order - b.order)
                    this.error_classifications.sort((a, b) => a.order - b.order)
                    this.repair_periods.sort((a, b) => a.order - b.order)

                    if (!this.classification_result) {
                        // we set danger aspect, error_indication etc. from the model on this.classification_result
                        // this is the old way to do it, but we need to keep it for now
                        this.classification_result = {
                            danger_aspect_id: this.editable_model.danger_aspect_id,
                            error_indication_id: this.editable_model.error_indication_id,
                            error_classification_id: this.editable_model.error_classification_id,
                            repair_period_id: this.editable_model.repair_period_id,
                        }

                        // now we check if the model has a classification and it has an object with all the columns
                        // if so, we set the classification_result to the object
                        if (this.editable_model.classification) {
                            this.classification_result = this.editable_model.classification
                        }
                    } else

                        // if editable_modal classification is same as model classification, we set the classification_result to the model classification
                        if (this.editable_model.classification.length == 0) {
                            this.classification_result = {
                                danger_aspect_id: this.editable_model.danger_aspect_id,
                                error_indication_id: this.editable_model.error_indication_id,
                                error_classification_id: this.editable_model.error_classification_id,
                                repair_period_id: this.editable_model.repair_period_id,
                            }
                        }
                }

            this.loading = false
        },
        setErrorClassification(error_indication_id) {
            let error_classification = this.error_indications.find(error_indication => error_indication.id == error_indication_id)

            if (error_classification) {
                this.classification_result.error_classification_id = error_classification.error_classification_id
                this.setRepairPeriod(error_classification.error_classification_id)
            }
        },
        setRepairPeriod(error_classification_id) {
            let repair_period = this.error_classifications.find(error_classification => error_classification.id == error_classification_id)

            if (repair_period) {
                this.classification_result.repair_period_id = repair_period.repair_period_id;
            }
        },

    },
    computed: {
        getErrorIndications() {
            return this.error_indications.filter(error_indication => {
                return error_indication.danger_aspect_id == this.classification_result.danger_aspect_id
            })
        },
    },
    watch: {
        classification_result: {
            handler(val) {
                if (val) {
                    this.$emit('change', this.classification_result)
                }
            },
            deep: true,
            immediate: true
        },
        "editable_model.is_defect": {
            handler(val) {
                this.$emit('setIsDefect', this.editable_model.is_defect)
            },
            deep: true,
            immediate: false
        },
        model: {
            handler(val) {
                // if conf we do setup again
                if (this.$store.getters.getInspectionMethodCode === 'CONF') {
                    this.setup()
                }
            },
            deep: true,
            immediate: false
        },
        "model.classification": {
            handler(val) {
                if (val && this.editable_model.is_defect) {
                    if (this.$store.getters.getInspectionMethodCode === 'IB22' && typeof val === 'object') {
                        this.classification_result = val
                    }
                }
            },
            deep: true,
            immediate: false
        }

    },
}


</script>
<style lang="">

</style>
